import React from 'react'

const Address = ({ address }) => {
  return (
    <div className="flex flex-col">
      <span className="text-gray-500 font-bold">Adresa</span>
      <hr className="w-[60%] bg-over-ternary-background mt-1" />
      <div className="mt-8 flex gap-3 text-over-primary-background lg:text-lg text-sm font-bold">
        <span>{address}</span>
      </div>
    </div>
  )
}

export default Address
